import { Grid, Typography } from '@mui/material'
import React from 'react'
import globalStyles from "../../../../assets/styles/global.module.scss";

const ArchiveChatNode = () => {
    
    return (
        <>
            <Grid item>
                <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight} ${globalStyles.greyColor}`}>
                    Archive Chat
                </Typography>
            </Grid>
        </>
    )
}

export default ArchiveChatNode
